module.exports = __webpack_public_path__ + "static/media/bathtub.29fcd699.svg";